import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { UserProfile } from '../model/user-profile';
import { UserProfileSelectedDTO } from '../model/user-profile-selected-dto';
import { AssocierProfileAEmployee } from '../model/associer-profile-a-employee';

@Injectable({
    providedIn: 'root'
  })
  export class UserProfileService{
  

    constructor(private _restClientService : RestClientService) 
    {}
    
    getUserProfiles() 
    {
      return this._restClientService.load<UserProfile[]>('user-profile/user-profile');
    }
      
    getUserProfileById(userProfileId){
      return this._restClientService.load<UserProfile>('user-profile/user-profile-by-id/'+userProfileId);
    }
      
    update(userProfile: UserProfile) {
      return  this._restClientService.put<UserProfile>(`user-profile/update-user-profile`, userProfile);
    }
        
    findSelectedProfiles(employeeId) 
    {
      return this._restClientService.load<UserProfileSelectedDTO[]>('user-profile/find-selected-profiles?employeeId='+employeeId);
    }

    associer(associerProfileAEmployee: AssocierProfileAEmployee) {
      return this._restClientService.save<UserProfile>('user-profile/associer-profile-employee', associerProfileAEmployee);
    }
    
    findProfilesForAffectation(taskid) 
    {
      return this._restClientService.load<UserProfile[]>('user-profile/find-selected-for-affectation?taskid='+taskid);
    }

  
}      

    